import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useMeasure } from 'react-use';
import { Typography } from 'ck-ui';
import styles from './SaleSash.module.scss';

const SaleSash = ({ text, textColor, bgColor, breakWord }) => {
  const [ref, { width }] = useMeasure();
  const style = { '--tri-bg-color': `#${bgColor}` };
  const textStyle = { color: `#${textColor}`, fontSize: `${width * 0.24}px` };
  const [before, ...after] = breakWord ? text.toLowerCase().split(breakWord.toLowerCase()) : [];

  return (
    <div
      className={styles.root}
      ref={ref}
      style={style}
    >
      <Typography
        className={classnames(styles.text, 'no-divider is-flex-centered')}
        variant="heading5"
        uppercase
        style={textStyle}
      >
        {breakWord ? (
          <>{before} <span className={styles.small}>{breakWord}</span> {after.join('')}</>
        ) : text}
      </Typography>
    </div>
  );
};

export { SaleSash };

SaleSash.propTypes = {
  bgColor: PropTypes.string,
  breakWord: PropTypes.string,
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
};

SaleSash.defaultProps = {
  bgColor: '#000000',
  breakWord: null,
  textColor: '#fff',
};
